module.exports = __webpack_public_path__ + "media/images/landing/home/categories/drink-6c80b89588e4feb22fd8b03c8cf330c9.png";